<template>
  <div class="chat-group-list-wrapper">
    <div class="header-morph-container" :style="{ height: `${currentHeaderHeight}px` }">
      <div class="header-large-content" :style="{ opacity: largeContentOpacity }">
        <v-btn icon dark absolute top left large class="mt-2 ml-1" @click="$router.push('/')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <img class="ml-2" :height="largeIconSize" src="/img/einmalig/roodyChatLogo.png"></img>
       <v-menu offset-y left content-class="glass-menu">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="hasCreateRight" top right absolute icon v-bind="attrs" v-on="on">
              <v-icon color="white">mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-list dense dark>
            <v-list-item @click="$emit('open-create-dialog')">
              <v-list-item-icon><v-icon>mdi-account-group-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Neue Gruppe</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$emit('open-broadcast-dialog')">
              <v-list-item-icon><v-icon>mdi-bullhorn-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Rundsendung</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
      </div>

      <v-toolbar dark flat color="grey darken-4" class="header-small-toolbar" :style="{ opacity: smallToolbarOpacity }">
        <v-btn icon @click="$router.push('/')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-icon class="ml-2" small>mdi-chat-processing-outline</v-icon>
        <v-toolbar-title class="ml-2 font-weight-bold" style="font-size: 1.1rem">Chats</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu offset-y left content-class="glass-menu">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="hasCreateRight" icon v-bind="attrs" v-on="on">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-list dense dark>
            <v-list-item @click="$emit('open-create-dialog')">
              <v-list-item-icon><v-icon>mdi-account-group-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Neue Gruppe</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$emit('open-broadcast-dialog')">
              <v-list-item-icon><v-icon>mdi-bullhorn-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Rundsendung</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
    </div>

    <v-toolbar flat dense dark style="background: #121212 !important" class="search-bar-absolute" :style="{ top: `${currentHeaderHeight}px` }">
      <v-text-field
        v-model="searchQuery"
        placeholder="Gruppen filtern..."
        filled
        rounded
        dense
        hide-details
        dark
        clearable
        prepend-inner-icon="mdi-magnify"
        class="glass-search-field"></v-text-field>
    </v-toolbar>

    <div ref="scrollContainer" class="group-list-scroll-area" @scroll="handleScroll">
      <div class="content-spacer" :style="{ height: `${currentSpacerHeight}px` }"></div>

<div v-if="isLoadingGroups" class="pa-2">
        <v-skeleton-loader
          v-for="n in 8"
          :key="n"
          type="list-item-avatar-two-line"
          class="mb-2 glass-skeleton"
          dark
        ></v-skeleton-loader>
      </div>
      <div class="group-list-content pa-2">
        <v-card
          @click="openPinboard"
          dark
          rounded="lg"
          class="mb-2 glass-card"
          :class="{ 'active-group-card': activeView === 'pinboard' }"
          elevation="0">
          <v-list-item class="pa-2">
            <v-list-item-avatar color="primary darken-2">
              <v-icon dark>mdi-pin</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Pinboard</v-list-item-title>
              <v-list-item-subtitle>Alle gemerkten Nachrichten</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
        <div v-if="!isLoadingGroups && chatGroups.length > 0 && filteredGroups.length === 0" class="text-center grey--text pa-8">
          <v-icon size="60" color="grey darken-2">mdi-magnify-close</v-icon>
          <p class="mt-4 headline">Keine Treffer</p>
          <p class="body-1">Für "{{ searchQuery }}" wurde keine Gruppe gefunden.</p>
        </div>
        <v-scroll-y-transition group>
        <v-card
          v-for="(group, index) in filteredGroups"
          :key="group ? group._id : 'empty-' + index"
          v-if="group"
          @click="selectGroup(group._id)"
          dark
          rounded="lg"
          class="mb-2 glass-card"
          :class="{ 'active-group-card': group._id === activeGroupId }"
          elevation="0">
          <v-list-item class="pa-2">
            <v-badge :value="isAnyoneOnline(group)" color="primary" dot bordered overlap offset-x="10" offset-y="10" class="mr-3">
              <v-list-item-avatar color="grey darken-2">
                <v-img v-if="group.bild" :src="'/img/profilbilder/' + group.bild" alt="Gruppenbild"></v-img>
                <v-icon v-else dark>mdi-account-group</v-icon>
              </v-list-item-avatar>
            </v-badge>

            <v-list-item-content>
              <v-list-item-title v-text="group.name" class="font-weight-bold"></v-list-item-title>

              <v-list-item-subtitle class="text-truncate" :class="{ 'typing-indicator-text': getTypingData(group).isTyping }">
                {{ getSubtitle(group) }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-list-item-action-text class="caption mb-1">
                {{ formatLastMessageTime(group.lastMessage && group.lastMessage.createdAt) }}
              </v-list-item-action-text>

              <v-badge :value="group.hasUnread" color="primary" dot inline v-if="group.hasUnread">
                <v-icon v-if="group.isMentioned" small color="primary lighten-1" style="margin-top: -3px"> mdi-at </v-icon>
              </v-badge>
            </v-list-item-action>
          </v-list-item>
        </v-card>
        </v-scroll-y-transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex"

// --- KONSTANTEN FÜR DIE ANIMATION ---
const MIN_HEADER_HEIGHT = 56 // Höhe der finalen Toolbar
const SEARCH_BAR_HEIGHT = 56 // Höhe der Suchleiste

export default {
  name: "ChatGroupList",
  props: {
    hasCreateRight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchQuery: "",
      scrollTop: 0,
      maxHeaderHeight: 200, // Start-Höhe (wird in mounted() berechnet)
    }
  },

  mounted() {
    this.maxHeaderHeight = window.innerHeight * 0.25 // 25vh
  },

  computed: {
    ...mapState("userStore", ["user"]),
    ...mapState("chatStore", ["chatGroups", "activeGroupId", "isLoadingGroups", "typingUsers", 'activeView']),
    ...mapGetters("chatStore", ["getPresenceByUserId"]),

    /**
     * Gibt einen Wert von 0 (ganz oben) bis 1 (komplett gescrollt) zurück
     */
    scrollProgress() {
      const scrollRange = this.maxHeaderHeight - MIN_HEADER_HEIGHT
      if (scrollRange <= 0) return 1
      return Math.max(0, Math.min(1, this.scrollTop / scrollRange))
    },

    /**
     * Berechnet die AKTUELLE Höhe des Headers (animiert)
     */
    currentHeaderHeight() {
      const heightDiff = this.maxHeaderHeight - MIN_HEADER_HEIGHT
      return this.maxHeaderHeight - heightDiff * this.scrollProgress
    },

    /**
     * NEU: Berechnet die Höhe des unsichtbaren Spacers
     * Das ist der Fix für den "Wackler".
     */
    currentSpacerHeight() {
      // === DER FIX FÜR DEN "WACKLER" ===
      // Die Höhe des Spacers ist JETZT FIX und ändert sich nicht mehr.
      // Er ist immer so hoch wie der MAXIMALE Header + Suche.
      return this.maxHeaderHeight + SEARCH_BAR_HEIGHT
    },

    /**
     * Berechnet die Opacity des GROSSEN Inhalts (Sanfter Fade)
     */
    largeContentOpacity() {
      const FADE_END = 0.7 // Bei 75% des Scroll-Wegs soll der Fade-Out fertig sein
      return Math.max(0, 1 - this.scrollProgress / FADE_END)
    },

    /**
     * Berechnet die Opacity der KLEINEN Toolbar (Sanfter Fade)
     */
    smallToolbarOpacity() {
      const FADE_START = 0.5 // Bei 25% des Scroll-Wegs soll der Fade-In starten
      const FADE_DURATION = 1 - FADE_START
      return Math.max(0, (this.scrollProgress - FADE_START) / FADE_DURATION)
    },

    /**
     * Berechnet die Größe des großen Icons (animiert)
     */
    largeIconSize() {
      return 100 - this.scrollProgress * 100
    },

    // --- Deine filteredGroups-Logik ---
    filteredGroups() {
      const query = this.searchQuery.toLowerCase().trim()
      if (!query) {
        return this.chatGroups
      }
      return this.chatGroups.filter((group) => {
        if (!group || !group.name) return false
        return group.name.toLowerCase().includes(query)
      })
    },
  },

  methods: {
    ...mapActions("chatStore", {
      selectGroup: "setActiveGroup",
      openPinboard: "openPinboard" // NEU
    }),

    handleScroll(event) {
      this.scrollTop = event.target.scrollTop
    },

    // --- DEINE BISHERIGEN METHODS ---
    isAnyoneOnline(group) {
      if (!group || !group.members) return false
      return group.members.some((member) => {
        if (!member.userId) return false
        const presence = this.getPresenceByUserId(member.userId._id)
        return presence && presence.isOnline
      })
    },

    formatLastMessageTime(timestamp) {
      if (!timestamp) return ""
      const date = new Date(timestamp)
      const today = new Date()
      const yesterday = new Date(today)
      yesterday.setDate(yesterday.getDate() - 1)
      if (date.toDateString() === today.toDateString()) {
        return date.toLocaleTimeString("de-CH", { hour: "2-digit", minute: "2-digit" })
      }
      if (date.toDateString() === yesterday.toDateString()) {
        return "Gestern"
      }
      return date.toLocaleDateString("de-CH", { day: "2-digit", month: "2-digit", year: "2-digit" })
    },

    getTypingData(group) {
      if (!this.typingUsers || !this.user || !group.members) {
        return { isTyping: false, text: "" }
      }
      const typingIds = this.typingUsers[group._id] || []
      const tippers = group.members.filter((member) => typingIds.includes(member.userId._id) && member.userId._id !== this.user._id)
      const count = tippers.length
      if (count === 0) return { isTyping: false, text: "" }
      let text = ""
      if (count === 1) text = `${tippers[0].userId.vorname} schreibt...`
      else if (count === 2) text = `${tippers[0].userId.vorname} und ${tippers[1].userId.vorname} schreiben...`
      else text = "Mehrere Personen schreiben..."
      return { isTyping: true, text: text }
    },

    getSubtitle(group) {
      const typingData = this.getTypingData(group)
      if (typingData.isTyping) {
        return typingData.text
      }
      if (group.lastMessage && group.lastMessage.textContent) {
        const sender = group.lastMessage.senderId
        const text = group.lastMessage.textContent
        if (sender && this.user && sender._id === this.user._id) {
          return `Du: ${text}`
        }
        if (sender && sender.vorname) {
          return `${sender.vorname}: ${text}`
        }
        return text
      }
      const memberCount = group.members ? group.members.length : 0
      return `${memberCount} Mitglieder`
    },
  },
}
</script>

<style lang="scss" scoped>
/*
 * BASIS-LAYOUT (DIE NEUE ARCHITEKTUR)
 */
.chat-group-list-wrapper {
  height: 100%;
  width: 100%;
  position: relative; /* Anker für die 'absolute' Header */
  overflow: hidden;
  background-color: var(--v-grey-darken4);
}

/*
 * 1. DER MORPH-HEADER (ABSOLUT)
 */
.header-morph-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0; /* width: 100% */
  z-index: 2; /* Liegt über der Suche und dem Scroller */

  will-change: height; /* Performance-Hint für Browser */
  overflow: hidden;
  background-color: var(--v-grey-darken4);

  /* Schatten, wenn er "klein" ist (als Toolbar) */
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

.header-large-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  will-change: opacity;
  transition: opacity 0.1s linear; /* Schneller Fade */
}

.header-small-toolbar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  will-change: opacity;
  transition: opacity 0.1s linear; /* Schneller Fade */
  background-color: transparent !important;
}

/*
 * 2. DIE SUCHE (ABSOLUT)
 */
.search-bar-absolute {
  position: absolute;
  left: 0;
  right: 0; /* width: 100% */
  z-index: 1; /* Liegt unter dem Morph-Header */

  /* Wichtig: 'top' wird per JS gesetzt, 'height' ist fix (dense) */
  will-change: top; /* Performance-Hint */
  background-color: var(--v-grey-darken4);
}

/*
 * 3. DER SCROLLER
 */
.group-list-scroll-area {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative; /* Wichtig für den Scroll-Flow */
  z-index: 0; /* Liegt HINTER den 'absolute' Headern */
}

/*
 * 4. DER SPACER
 */
.content-spacer {
  /* Dieser Block ist unsichtbar und schiebt nur den Inhalt runter */
  width: 100%;
  /* 'height' wird per JS gesetzt */

  /* * DER FIX FÜR DEN "WACKLER" (im <script>):
   * Die Höhe ist jetzt FIX (maxHeaderHeight + searchHeight)
   * und animiert sich NICHT mehr. 
   * 'will-change' wird nicht mehr gebraucht.
   */
}

/*
 * 5. DEIN BESTEHENDES GLASS-STYLING
 */
.glass-card {
  background-color: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  transition: all 0.2s ease-out;
  @media (hover: hover) {
    &:hover {
      background-color: rgba(255, 255, 255, 0.08) !important;
      transform: translateY(-1px);
    }
  }
}
.active-group-card {
  background-color: rgba(0, 150, 63, 0.1) !important;
  border-color: rgba(0, 150, 63, 0.7) !important;
  box-shadow: 0 0 15px -5px rgba(0, 150, 63, 0.4);
}
.typing-indicator-text {
  color: var(--v-primary) !important;
  font-weight: 600;
  font-style: italic;
}
.glass-search-field {
  ::v-deep .v-input__slot {
    background: rgba(255, 255, 255, 0.05) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    box-shadow: none !important;
  }
  ::v-deep .v-input__append-inner {
    margin-top: 6px !important;
  }
}
::v-deep .glass-skeleton .v-skeleton-loader__list-item-avatar-two-line {
  background: rgba(255, 255, 255, 0.03) !important;
  border-radius: 12px;
}
::v-deep .glass-skeleton .v-skeleton-loader__avatar,
::v-deep .glass-skeleton .v-skeleton-loader__text {
  background: rgba(255, 255, 255, 0.1) !important;
}
</style>
